import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Login.css';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isLocked, setIsLocked] = useState(false);
  const [remainingAttempts, setRemainingAttempts] = useState(null);
  const { login, continueAsGuest } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    setIsLocked(false);
    setRemainingAttempts(null);

    try {
      await login(username, password);
      navigate('/');
    } catch (err) {
      setError(err.message);
      setIsLocked(err.locked || false);
      setRemainingAttempts(err.remaining_attempts || null);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>Crypto<span className="brand-accent">Vision</span></h1>
          <p>Најавете се за да пристапите до вашата контролна табла</p>
        </div>
        {error && (
          <div className={`alert ${isLocked ? 'alert-error' : 'alert-warning'}`}>
            {error}
            {remainingAttempts !== null && remainingAttempts > 0 && !isLocked && (
              <div style={{ marginTop: '8px', fontSize: '0.9em' }}>
                Остануваат {remainingAttempts} обиди пред блокирање.
              </div>
            )}
          </div>
        )}
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="username">Корисничко име</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              disabled={isLoading || isLocked}
              placeholder="Внесете корисничко име"
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Лозинка</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={isLoading || isLocked}
              placeholder="Внесете лозинка"
            />
          </div>
          <button
            type="submit"
            className="button button-primary login-button"
            disabled={isLoading || isLocked}
          >
            {isLoading ? 'Најавување...' : 'Најави се'}
          </button>
        </form>
        <div className="login-footer">
          <p>
            Немате профил? <Link to="/register">Регистрирајте се</Link>
          </p>
        </div>
        <div className="login-divider">
          <span>или</span>
        </div>
        <button
          type="button"
          className="button button-outline guest-button"
          onClick={() => {
            continueAsGuest();
            navigate('/');
          }}
        >
          Продолжи како гостин
        </button>
      </div>
    </div>
  );
}

export default Login;
